/**
 * useInvoiceHistory — the Rechnungskontrolle Verlauf timeline (Story UI-U4).
 *
 * live mode → GET /admin/invoice-check/:id/history; a 403/404 (permission-gated
 *             surface) or any read failure resolves to `null` (fetchHistory
 *             swallows it) — NOT an error state — so the Verlauf section HIDES
 *             gracefully (defensive rule AC 5).
 * mock mode → resolves HISTORY_MOCK[id] (null when absent → section hidden).
 *
 * [Source: apps/web/src/features/invoices/hooks/useInvoiceRows.ts] (live/mock split)
 */

import { useQuery } from '@tanstack/react-query';
import type { InvoiceHistoryResult } from '../../../lib/api-client';
import { qk } from '../../../lib/query-keys';
import { isLiveData } from '../../../lib/data-mode';
import { fetchHistory } from '../api/invoices-api';
import { HISTORY_MOCK } from '../mock';

export function useInvoiceHistory(id: string | null) {
  const live = isLiveData();
  return useQuery<InvoiceHistoryResult | null>({
    queryKey: qk.invoiceHistory(id ?? 'none'),
    queryFn: () =>
      live
        ? fetchHistory(id as string)
        : Promise.resolve(HISTORY_MOCK[id as string] ?? null),
    enabled: id !== null,
  });
}
